/* Icons */
import './styles.scss'

let defaults = {
    API_URL: '/api/v1/file-uploads'
}

import Vue from 'vue'
Vue.component('vue-medialibrary-manager',() => import( /* webpackChunkName: "js/components/medialibrary-manager" */  './components/Manager'))
Vue.component('vue-medialibrary-field', () => import(  /* webpackChunkName: "js/components/medialibrary-field" */  './components/Field'))
Vue.component('vue-medialibrary-editor', () => import(  /* webpackChunkName: "js/components/medialibrary-editor2" */  "./components/Editor"))

import Editor from './components/Editor'
Vue.prototype.$medialibrary = defaults
export {Editor}
